import axios from 'axios';

// Configure axios to use the API base URL
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://localhost:7271/api';

// Add authorization token to all requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export interface UserDto {
  id: number;
  fullName: string;
  email: string;
  phone: string;
  permissionLevel: number;
  permissionLevelName: string;
  isSupervisor: boolean;
  isPartialSupervisor: boolean;
  isActive: boolean;
  defaultCommissionFixedAmount: number;
  defaultCommissionPercentage: number;
  createdAt: string;
  updatedAt: string;
}

export const usersApi = {
  getSalesReps: async (): Promise<UserDto[]> => {
    const response = await axios.get('/users/sales-reps');
    return response.data;
  },

  getCaseManagers: async (): Promise<UserDto[]> => {
    const response = await axios.get('/users/case-managers');
    return response.data;
  },

  getAll: async (): Promise<UserDto[]> => {
    const response = await axios.get('/users');
    return response.data;
  }
};